import { MODULE_CATALOG } from "@botwsp/shared";

export interface ConfigField {
  key: string;
  type: "string" | "number" | "boolean" | "stringArray";
  label: string;
}

/**
 * Keys rendered by dedicated sub-editors; the generic field list must skip them
 * so they don't appear twice (and to avoid corrupting object arrays).
 */
const STRUCTURED_KEYS: Record<string, string[]> = {
  faq: [
    "faq_items",
    "welcome_message",
    "fallback_message",
    "farewell_message",
    "farewell_keywords",
    "chaining_messages",
  ],
  lead_capture: ["custom_fields", "required_fields"],
};

/**
 * Build a flat list of editable fields for a module config using the shared
 * catalog's `configFields` and the current values (to infer types).
 */
export function buildFields(
  code: string,
  current: Record<string, unknown>,
): ConfigField[] {
  const def = MODULE_CATALOG.find((m) => m.code === code);
  const keys = (def?.configFields ?? Object.keys(current)).filter(
    (k) => !(STRUCTURED_KEYS[code] ?? []).includes(k),
  );

  return keys.map((key) => {
    const value = current[key];
    let type: ConfigField["type"] = "string";
    if (typeof value === "boolean") type = "boolean";
    else if (typeof value === "number") type = "number";
    else if (Array.isArray(value)) type = "stringArray";
    return { key, type, label: prettyLabel(key) };
  });
}

export function prettyLabel(key: string): string {
  return key
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}